export const FETCH_DISCOUNTS_REQUEST = "FETCH_DISCOUNTS_REQUEST";
export const FETCH_DISCOUNTS_SUCCESS = "FETCH_DISCOUNTS_SUCCESS";
export const FETCH_DISCOUNTS_FAILURE = "FETCH_DISCOUNTS_FAILURE";

export const FETCH_DISCOUNT_REQUEST = "FETCH_DISCOUNT_REQUEST";
export const FETCH_DISCOUNT_SUCCESS = "FETCH_DISCOUNT_SUCCESS";
export const FETCH_DISCOUNT_FAILURE = "FETCH_DISCOUNT_FAILURE";

export const CREATE_DISCOUNT_REQUEST = "CREATE_DISCOUNT_REQUEST";
export const CREATE_DISCOUNT_SUCCESS = "CREATE_DISCOUNT_SUCCESS";
export const CREATE_DISCOUNT_FAILURE = "CREATE_DISCOUNT_FAILURE";

export const UPDATE_DISCOUNT_REQUEST = "UPDATE_DISCOUNT_REQUEST";
export const UPDATE_DISCOUNT_SUCCESS = "UPDATE_DISCOUNT_SUCCESS";
export const UPDATE_DISCOUNT_FAILURE = "UPDATE_DISCOUNT_FAILURE";

export const DELETE_DISCOUNT_REQUEST = "DELETE_DISCOUNT_REQUEST";
export const DELETE_DISCOUNT_SUCCESS = "DELETE_DISCOUNT_SUCCESS";
export const DELETE_DISCOUNT_FAILURE = "DELETE_DISCOUNT_FAILURE";

export const SET_DISCOUNT_FILTERS = "SET_DISCOUNT_FILTERS";
export const RESET_DISCOUNT_FILTERS = "RESET_DISCOUNT_FILTERS";

export const FETCH_DISCOUNT_COUPONS_REQUEST = "FETCH_DISCOUNT_COUPONS_REQUEST";
export const FETCH_DISCOUNT_COUPONS_SUCCESS = "FETCH_DISCOUNT_COUPONS_SUCCESS";
export const FETCH_DISCOUNT_COUPONS_FAILURE = "FETCH_DISCOUNT_COUPONS_FAILURE";

export const GENERATE_DISCOUNT_COUPONS_REQUEST = "GENERATE_DISCOUNT_COUPONS_REQUEST";
export const GENERATE_DISCOUNT_COUPONS_SUCCESS = "GENERATE_DISCOUNT_COUPONS_SUCCESS";
export const GENERATE_DISCOUNT_COUPONS_FAILURE = "GENERATE_DISCOUNT_COUPONS_FAILURE";

export const MARK_DISCOUNT_COUPONS_PRINTED_REQUEST = "MARK_DISCOUNT_COUPONS_PRINTED_REQUEST";
export const MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS = "MARK_DISCOUNT_COUPONS_PRINTED_SUCCESS";
export const MARK_DISCOUNT_COUPONS_PRINTED_FAILURE = "MARK_DISCOUNT_COUPONS_PRINTED_FAILURE";

export const MARK_DISCOUNT_COUPONS_USED_REQUEST = "MARK_DISCOUNT_COUPONS_USED_REQUEST";
export const MARK_DISCOUNT_COUPONS_USED_SUCCESS = "MARK_DISCOUNT_COUPONS_USED_SUCCESS";
export const MARK_DISCOUNT_COUPONS_USED_FAILURE = "MARK_DISCOUNT_COUPONS_USED_FAILURE";

export const FETCH_DISCOUNT_APPROVALS_REQUEST = "FETCH_DISCOUNT_APPROVALS_REQUEST";
export const FETCH_DISCOUNT_APPROVALS_SUCCESS = "FETCH_DISCOUNT_APPROVALS_SUCCESS";
export const FETCH_DISCOUNT_APPROVALS_FAILURE = "FETCH_DISCOUNT_APPROVALS_FAILURE";

export const FETCH_DISCOUNT_HISTORY_REQUEST = "FETCH_DISCOUNT_HISTORY_REQUEST";
export const FETCH_DISCOUNT_HISTORY_SUCCESS = "FETCH_DISCOUNT_HISTORY_SUCCESS";
export const FETCH_DISCOUNT_HISTORY_FAILURE = "FETCH_DISCOUNT_HISTORY_FAILURE";

export const APPROVE_DISCOUNT_REQUEST = "APPROVE_DISCOUNT_REQUEST";
export const APPROVE_DISCOUNT_SUCCESS = "APPROVE_DISCOUNT_SUCCESS";
export const APPROVE_DISCOUNT_FAILURE = "APPROVE_DISCOUNT_FAILURE";

export const REJECT_DISCOUNT_REQUEST = "REJECT_DISCOUNT_REQUEST";
export const REJECT_DISCOUNT_SUCCESS = "REJECT_DISCOUNT_SUCCESS";
export const REJECT_DISCOUNT_FAILURE = "REJECT_DISCOUNT_FAILURE";
